var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"config"},[_c('el-form',[_c('x-form',{attrs:{"label":"用户id"},model:{value:(_vm.uid),callback:function ($$v) {_vm.uid=$$v},expression:"uid"}})],1),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.create}},[_vm._v("确认")]),_c('div',{staticClass:"token"},[_vm._v(_vm._s(_vm.token))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }